import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Color property - Definition */
export class DocsBlockColorPropertyDefinition extends DocsBlockPropertyDefinition {
}
